import request from './core/request'

// 关注商家相关API
export default {
	//查询会员是否关注
	isStoreCollection: (id) => request.get(`member/storeCollection/isCollection/STORE/${id}`, {}, {}),
	//添加会员店铺关注
	addStoreCollection: (id) => request.post(`member/storeCollection/add/STORE/${id}`, {}, {}),
	//删除会员店铺关注
	delStoreCollection: (id) => request.delete(`member/storeCollection/delete/STORE/${id}`, {}, {}),
	//会员店铺关注列表
	getStoreCollectionList: (params) => request.get(`member/storeCollection/STORE`, params, {}),
	//添加会员收藏商品
	addGoodsCollection: (id) => request.post(`member/collection/add/GOODS/${id}`, {}, {}),
	//删除会员收藏商品
	delGoodsCollection: (id) => request.delete(`member/collection/delete/GOODS/${id}`, {}, {}),
	//查询会员是否收藏商品
	isGoodsCollection: (id) => request.get(`member/collection/isCollection/GOODS/${id}`, {}, {}),
	//查询会员收藏商品列表
	getGoodsCollectionList: (params) => request.get(`member/collection/GOODS`, params, {})
}